export const DRAWER_COMBOBOX_PROPS = {
  withinPortal: true,
  zIndex: 1001,
  position: "bottom-start" as const,
  middlewares: { flip: true, shift: true },
};